<svelte:options accessors={true} />

<script lang="ts">
	import { createEventDispatcher } from "svelte";
	import { clickOutside } from "./clickOutside";

	export let node;
	export let network;
	export let data;

	let shown = false;

	let dispatch = createEventDispatcher();

	let testData = data.edges.get({
		filter: function (item) {
			return item.to == node.id || item.from == node.id;
		}
	});

	export function show() {
		shown = !shown;
		dispatch("show", shown);
	}
</script>

<div
	id="node-{node.id}"
	class="node"
	class:selected={shown}
	tabindex={node.id}
	use:clickOutside
	on:click_outside={shown && show}
>
	<div
		class="header"
		on:click={() => {
			network.focus(node.id, {
				scale: 1,
				animation: {
					duration: 6000,
					easingFunction: "easeOutQuart"
				}
			});
			network.selectNodes([node.id]);
			show();
		}}
	>
		{node.title}
	</div>

	{#if shown}
		<div class="moreData">
			<div class="flex-item">ID:</div>
			<div class="flex-item">
				{node.id}
			</div>
			<div class="flex-item">Title</div>
			<div class="flex-item">
				<input type="text" bind:value={node.title} />
			</div>
			<div class="flex-item">Label</div>
			<div class="flex-item">
				<textarea bind:value={node.label} />
			</div>
			<div class="flex-item">Group</div>
			<div class="flex-item">
				<input type="text" bind:value={node.group} />
			</div>

			<div class="flex-item">Debug Node:</div>
			<div class="flex-item">
				<textarea>{JSON.stringify({ node }, null, 2)}</textarea>
			</div>
			<div class="flex-item">Debug Links:</div>
			<div class="flex-item">
				<textarea>{JSON.stringify(testData, null, 2)}</textarea>
			</div>
			<div class="flex-item-button">
				<button
					on:focus={() => {
						data.nodes.update({ title: node.title, id: node.id, label: node.label, group: node.group });
					}}>Update</button
				>
			</div>
			<div class="flex-item-button">
				<button
					on:focus={() => {
						data.nodes.remove([node.id]);
					}}>Delete</button
				>
			</div>
		</div>
	{/if}
</div>

<style>
	.header {
		background: rgba(89, 89, 89, 0.9);
		margin-bottom: 1px;
		padding: 10px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.selected {
		background: rgba(56, 56, 56, 0.9);
	}

	.moreData {
		background: rgba(89, 89, 89, 0.32);
		min-height: 60px;
		padding: 10px;
		display: flex;
		flex-wrap: wrap;
		width: auto;
	}
	.flex-item {
		flex: 25%;
	}

	.flex-item:nth-child(even) {
		flex: 75%;
	}

	textarea {
		width: 100%;
		height: 150px;
	}
	input {
		width: 100%;
	}

	.node.selected > .header {
		background: rgba(56, 56, 56, 0.9);
	}

	.flex-item-button {
		flex: 1;
	}

	.flex-item-button button {
		width: 100%;
	}
</style>
